import { useCallback } from 'react'
import { generatePath, useNavigate } from 'react-router-dom'

import { routes } from '~config'
import { useToast } from '~context/ToastContext'
import { useSurvey, useThreads } from '~hooks'

const useMenteeConversation = () => {
  const navigate = useNavigate()
  const { addToast } = useToast()
  const { useGetThreads } = useThreads()
  const { useGetMatchings } = useSurvey()
  const { refetch: refetchThreads } = useGetThreads()
  const { data: matchings } = useGetMatchings()

  const openMenteeConversation = useCallback(
    async (menteeUserId: number) => {
      const matching = matchings?.find((m) => m.young.id === menteeUserId)

      if (!matching) {
        addToast({
          type: 'info',
          title: 'Discussion non disponible',
          subtitle:
            'Le parrainage doit être actif pour accéder à la discussion.',
        })
        return
      }

      const { data: updatedThreads } = await refetchThreads()

      const thread = updatedThreads?.find((t) =>
        t.participants.some((p) => p.id === menteeUserId)
      )

      if (thread) {
        navigate(
          generatePath(routes.authenticated.messaging, {
            id: String(thread.id),
          })
        )
      } else {
        addToast({
          type: 'warning',
          title: 'Discussion introuvable',
          subtitle:
            "La discussion n'a pas encore été créée. Veuillez réessayer dans quelques instants.",
        })
      }
    },
    [matchings, refetchThreads, navigate, addToast]
  )

  return { openMenteeConversation }
}

export default useMenteeConversation
